import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject;
import styled from 'styled-components';
export var Divider = styled.hr(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  border: 0;\n  margin: 0;\n  height: 1px;\n  background-color: var(--color-border-muted);\n"])));